import type { PresenceDictionary } from '../wcContracts'

const presence: PresenceDictionary = {
  history: { title: '기존 게시 콘텐츠', body: '기업의 이전 게시 콘텐츠와 날짜를 확인합니다. 원본 페이지를 열어도 다시 게시되지 않습니다.', publishedOn: '게시일: {date}', recordedPages: '개의 기록된 게시 URL', receptionLoading: '응대 설정을 불러오는 중…', receptionUnavailable: '응대 설정을 불러오지 못했습니다. 기존 웹사이트 콘텐츠는 아래에서 확인할 수 있습니다.' },
  page: { title: '채널 현황', intro: '콘텐츠가 게시된 위치를 확인하고 필요한 작업을 완료하세요.' },
  overview: { officialSite: '공식 사이트', searchSubmission: '검색 등록 제출', needsAction: '조치 필요', online: '온라인', submitted: '제출됨' },
  queue: { title: '콘텐츠 작업 대기열', all: '전체', needsAction: '조치 필요', inProgress: '처리 중', published: '게시됨', taskCount: '작업 {count}개' },
  state: { manualPrepared: '수동 단계 준비됨', reviewReady: '검토 준비됨', processing: '처리 중', published: '게시됨' },
  manual: { title: '게시 완료', noDuplicate: '중복 게시되지 않았습니다.', fallbackBody: '자동 게시가 완료되지 않아 수동 단계를 준비했습니다.', copy: '준비된 콘텐츠 복사', openDestination: '게시 대상 열기', publicUrl: '게시 후 공개 URL', markPublished: '게시됨으로 표시', saved: '게시 완료로 저장되었습니다.' },
  common: { websiteStatus: '웹사이트 상태', distribution: '배포', details: '게시 상세 정보', technicalRecord: '기술 기록 보기', demoData: '데모 데이터' },
  site: {
  "back": "웹사이트 목록",
  "switchSite": "웹사이트 전환",
  "single": "이 프로젝트의 유일한 웹사이트",
  "navigation": "웹사이트 관리",
  "manage": "웹사이트 관리",
  "manageAirlock": "Airlock 관리",
  "pageCount": "개의 방문자용 페이지",
  "viewPages": "페이지 보기",
  "todoCount": "처리가 필요한 응대 항목 {count}개",
  "languageBody": "웹사이트 콘텐츠 언어는 게시 대상에 따르며 UI 언어와 별개입니다.",
  "pagesBody": "현재 사이트 버전의 페이지와 지원 응대 형식입니다. 설정은 Airlock에서 합니다.",
  "noBuild": "아직 검증된 사이트 버전이 없습니다. 생성 및 검증 후 페이지가 표시됩니다.",
  "machinePages": "기계 판독용 파일",
  "readerPages": "방문자 페이지",
  "machineNoSlot": "응대 UI 설치 없음",
  "noSlot": "설치 가능한 위치가 아직 없습니다",
  "originalTodo": "원래 항목으로 돌아왔습니다",
  "todoUnavailable": "원래 항목을 찾을 수 없습니다. 이 사이트의 최신 항목을 확인하세요.",
  "todoResolved": "이 항목은 처리되었습니다.",
  "todoOpen": "아직 처리 중입니다. 자료를 제출해도 자동으로 해결되지 않습니다.",
  "domain": "웹사이트 주소",
  "environmentLabel": "게시 환경",
  "installation": "연결 방식",
  "connected": "자동 배포 연결됨",
  "guided": "설치 안내 필요",
  "connectedBody": "승인된 사이트 연결로 게시합니다. 게시 전에 대상과 범위가 표시됩니다.",
  "guidedBody": "지원되는 자동 배포 연결이 없습니다. Airlock에서 설치 안내를 확인하세요. 여기서 자동 게시할 수는 없습니다.",
  "deployBoundary": "이 페이지를 보는 것만으로 콘텐츠 생성, 배포, 모델 호출이 실행되지 않습니다.",
  "unavailable": "선택한 사이트를 사용할 수 없습니다. 목록에서 선택하세요. 다른 사이트로 자동 전환하지 않습니다.",
  "connect": "기존 웹사이트 연결",
  "create": "새 웹사이트 만들기",
  "emptyBody": "먼저 웹사이트를 준비한 뒤 Airlock을 활성화하세요. 게시 대상을 임의로 정하지 않습니다.",
  "connectHelp": "사이트 주소, 관리 권한, 지원 연결 방식이 필요합니다. 셀프 연결은 아직 제공되지 않으므로 프로젝트 담당자에게 사이트 설정을 요청하세요.",
  "createHelp": "새 사이트는 콘텐츠와 호스팅 주소 확인이 필요합니다. 셀프 생성은 아직 제공되지 않으며 설정된 사이트는 이 목록에 표시됩니다.",
  "tabs": {
    "overview": "개요",
    "pages": "페이지 및 게시",
    "airlock": "Airlock",
    "deploy": "도메인 및 배포"
  },
  "environment": {
    "production": "운영",
    "staging": "테스트"
  },
  "airlockState": {
    "preparing": "준비 중",
    "ready": "준비 완료",
    "publishing": "게시 중",
    "live": "응대 중",
    "paused": "일시 중지",
    "failed": "처리 필요"
  },
  "slot": {
    "widget": "플로팅 응대",
    "inline": "페이지 내 응대",
    "focus": "집중 응대"
  }
},
  material: {
  "pending_domain": "자료를 받았습니다. 사용 범위 확인 대기 중이며 아직 응대 지식에 반영되지 않았습니다.",
  "awaiting_knowledge_confirmation": "공개 자료로 분류되었습니다. 지식 정리와 확인이 필요하며 응대에 아직 동기화되지 않았습니다.",
  "private_only": "이 자료는 비공개이므로 외부 답변에 사용할 수 없습니다. 공개 자료를 추가하거나 답변 범위를 설정하세요.",
  "synced": "승인된 공개 자료가 이 프로젝트의 Airlock 지식에 반영되었습니다. Airlock으로 돌아가 다시 테스트할 수 있습니다.",
  "loadError": "자료 진행 상태를 불러올 수 없습니다. 미제출 상태라는 뜻은 아닙니다. 잠시 후 다시 열어주세요.",
  "addMore": "자료 추가"
},
  workspace: {
    loading: '승인된 사이트를 불러오는 중…', error: '최신 사이트 상태를 불러오지 못했습니다.', empty: '승인된 사이트 또는 검증된 게시가 아직 없습니다.', authorisedSites: '개의 승인된 사이트', verifiedRoutes: '개의 검증된 공개 경로', preservedIssues: '개의 보존된 문제', eyebrow: '사이트 작업공간', title: '모든 공개 위치와 최신 검증 릴리스', siteCount: '사이트 {count}개', mode: '사이트 모드', managedStatic: 'Navigator 관리형 정적 사이트', languages: '지원 언어', lastDeploy: '최근 릴리스', machine: '머신 계층', noRelease: '이 사이트에는 아직 실행 게시 기록이 없습니다.',
    status: { configured: '설정됨', building: '구축 중', ready: '게시 가능', deploying: '배포 중', state_unknown: '상태 검증 필요', live: '온라인', failed: '확인 필요' }, machineStatus: { pending: '준비 중', verified: '검증됨', unknown: '알 수 없음 · 안전 중지', failed: '실패' },
  },
}

export default presence
